// extracted by mini-css-extract-plugin
export var actions = "_ib-g";
export var benefitCard = "_ib-b";
export var benefitIcon = "_ib-d";
export var benefitLabel = "_ib-f";
export var benefits = "_ib-a";
export var benefitsSection = "_ib-8";
export var bodyText = "_ib-7";
export var closeButton = "_ib-2";
export var content = "_ib-3";
export var eyebrow = "_ib-4";
export var heading = "_ib-5";
export var image = "_ib-i";
export var imagePanel = "_ib-h";
export var modal = "_ib-0";
export var offerCard = "_ib-c";
export var offerIcon = "_ib-e";
export var sectionLabel = "_ib-9";
export var shell = "_ib-1";
export var title = "_ib-6";